import React, { useEffect } from 'react';
import styles from './Footer.module.css';
import IconComponent from '../IconComponent/IconComponent';
import { FaInstagram, FaTiktok } from 'react-icons/fa';
import { useNavigate, Link } from 'react-router-dom';
import { useTranslation } from '../../TranslationProvider';

const Footer = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    return (
        <div className={styles.wrapper}>
            <div className={styles.left}>
                <div className={styles.logo} onClick={() => navigate("")}></div>
                <div className={styles.social_media}>
                    <div className={styles.social_media_title}>{t('find_us')}</div>
                    <div className={styles.social_media_links}>
                        <a href="https://www.instagram.com/hard.creative/" target="_blank" rel="noopener noreferrer">
                            <IconComponent icon={FaInstagram} size={20} />
                        </a>
                        <a href="https://www.tiktok.com/" target="_blank" rel="noopener noreferrer">
                            <IconComponent icon={FaTiktok} size={20} />
                        </a>
                    </div>
                </div>
            </div>

            <div className={styles.center}>
                <Link to="/about">{t('about_us')}</Link>
                <Link to="/projects">{t('projects')}</Link>
                <Link to="/about#contact">{t('contact_us')}</Link>
            </div>

            <div className={styles.right}>
                <a
                    href="https://open.spotify.com/playlist/3tpZMTlZCFZeAUCDHp7VuJ?si=ad5626211ef04d79"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Playlist
                </a>
                <a
                    href="https://www.iubenda.com/privacy-policy/73278887"
                    title="Privacy Policy"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Privacy Policy
                </a>
                <a
                    href="https://www.iubenda.com/privacy-policy/73278887/cookie-policy"
                    title="Cookie Policy"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Cookie Policy
                </a>
            </div>
        </div>
    );
};

export default Footer;